var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 43 44.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        isolation: isolate;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #d11664;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: url(#radial-gradient);\r\n        mix-blend-mode: multiply;\r\n        opacity: .8;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 21.5,
    cy: 23.19,
    fx: 21.5,
    fy: 23.19,
    r: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#7474a4",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#d8d8e5",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 21.5,
    cy: 23.19,
    r: 21.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.88,14.62C30.88,6.55,24.33,0,16.26,0S1.64,6.55,1.64,14.62c0,7.3,5.35,13.35,12.34,14.44v-10.22h-3.71v-4.23h3.71v-3.22c0-3.66,2.18-5.69,5.52-5.69,1.6,0,3.27,.29,3.27,.29v3.6h-1.84c-1.82,0-2.38,1.13-2.38,2.28v2.74h4.06l-.65,4.23h-3.41v10.22c6.99-1.1,12.34-7.15,12.34-14.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.95,18.85l.65-4.23h-4.06v-2.74c0-1.16,.57-2.28,2.38-2.28h1.84v-3.6s-1.67-.29-3.27-.29c-3.34,0-5.52,2.02-5.52,5.69v3.22h-3.71v4.23h3.71v10.22c.74,.12,1.51,.18,2.28,.18s1.54-.06,2.28-.18v-10.22h3.41Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFacebook);
export default __webpack_public_path__ + "static/media/logoFacebook.45664cc094487c360cfe4f6521300c30.svg";
export { ForwardRef as ReactComponent };